import { useEffect, useState } from "react";

import { ChangeRequestType, ChangeType, RequirementStatus } from "@repo/api";
import { usePrimaryAPIClient } from "../context/PrimaryAPIClient";

type UseHasCurrentContractsChangeResult =
	| { data: undefined; isSuccess: false }
	| { data: boolean; isSuccess: true };

type UseHasCurrentContactsChangeOptions = {
	enabled?: boolean;
};

// Returns has current contract change without caching
export const useHasCurrentContactsChange = ({
	enabled = true,
}: UseHasCurrentContactsChangeOptions = {}): UseHasCurrentContractsChangeResult => {
	const [state, setState] = useState<UseHasCurrentContractsChangeResult>({
		data: undefined,
		isSuccess: false,
	});
	const { changeRequestsApi } = usePrimaryAPIClient();
	useEffect(() => {
		// The request is intentionally local to this hook; ignore stale responses after unmount or disabled changes.
		let isActive = true;

		if (!enabled) {
			setState({ data: undefined, isSuccess: false });
			return () => {
				isActive = false;
			};
		}

		void (async () => {
			const data = await changeRequestsApi.getChangeRequestsGet({
				type: ChangeRequestType.Contract,
			});

			if (!isActive) {
				return;
			}

			setState({
				data: data.some(
					(change) =>
						change.changeType === ChangeType.ChangeElectronicContacts &&
						(change.status === RequirementStatus.New ||
							change.status === RequirementStatus.Waiting)
				),
				isSuccess: true,
			});
		})();

		return () => {
			isActive = false;
		};
	}, [changeRequestsApi, enabled]);

	return state;
};
